import styled from '@emotion/styled'

export const CalendarStyled = styled.div`
  font-family: 'DM Sans', sans-serif, 'Helvetica Neue', Arial, 'Noto Sans',
    sans-serif;
  .calendar-container {
    flex-grow: 1;
  }
  .content {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .calendar-title {
    height: 28px;
    line-height: 28px;
    border: 1px solid rgb(var(--ow-border-color));
    border-right: 0;
    color: #526484;
    font-weight: bold;
    text-align: center;
  }
  .calendar-title-left {
    border-radius: 4px 0 0;
  }
  .calendar-title-right {
    border-radius: 0 4px 0 0;
    border-right: 1px solid #dbdfea;
  }
  .calendar-box {
    height: 156px;
    width: 100%;
    border-width: 0 0 1px 1px;
    border-style: solid;
    border-color: rgb(var(--ow-border-color));
    color: #526484;
    position: relative;
    cursor: pointer;
  }
  .calendar-box:nth-child(7n + 0) {
    border-width: 0 1px 1px 1px;
  }
  .calendar-date {
    font-size: 0.85rem;
    right: 0.5rem;
    top: 0.5rem;
    position: absolute;
  }
  .calendar-other-date {
    opacity: 0.5;
  }
  .calendar-event {
    top: 1.8rem;
    width: 100%;
    position: absolute;
  }
  .event-content {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 6px;
  }
`

export const EventStyled = styled.div`
  width: 100%;
  font-size: 12px;
  border-radius: 3px;
  padding: 3px 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  display: flex;
  align-items: center;
  div {
    margin-right: 6px;
    width: 6px;
    height: 6px;
    border-radius: 4px;
    background-color: rgb(var(--ow-primary-color));
  }
`
